module.exports = __webpack_public_path__ + "static/media/logo.ac9797ad.png";